import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";

const MySwal = withReactContent(Swal2);

const EditWezwData = (props) => {
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [task, setTask] = useState("");
  const [plnValue, setPlnValue] = useState(
    props.clientsData.wezwPlnValue === null
      ? 0
      : +props.clientsData.wezwPlnValue.replaceAll(" ", "")
  );
  const [chfValue, setChfValue] = useState(
    props.clientsData.wezwChfValue === null ? 0 : props.clientsData.wezwChfValue
  );
  const [lastPaymentDate, setLastPaymentDate] = useState(
    props.clientsData.wezwLastPayDate === null
      ? 0
      : props.clientsData.wezwLastPayDate
  );
  const [payTime, setPayTime] = useState(
    props.clientsData.wezwPayTime === null ? 0 : props.clientsData.wezwPayTime
  );
  const [bank, setBank] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [bankAddressDb, setBankAddressDb] = useState("");
  const [dateOpt, setDateOpt] = useState(
    props.clientsData.wezwLastPayDate === null ||
      props.clientsData.wezwLastPayDate === "całkowitej spłaty kredytu"
      ? "2"
      : "1"
  );
  const [lawyersData, setLawyersData] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [koSkd, setKoSkd] = useState(
    props.clientsData.koSkd === null
      ? 0
      : +props.clientsData.koSkd.toString().replaceAll(" ", "")
  );
  const [izrSkd, setIzrSkd] = useState(
    props.clientsData.izrSkd === null ? 0 : props.clientsData.izrSkd
  );
  const [irSkd, setIrSkd] = useState(
    props.clientsData.irSkd === null ? 0 : props.clientsData.irSkd
  );
  const [kpSkd, setKpSkd] = useState(
    props.clientsData.kpSkd === null
      ? 0
      : +props.clientsData.kpSkd.toString().replaceAll(" ", "")
  );
  const [kupSkd, setKupSkd] = useState(
    props.clientsData.kupSkd === null
      ? 0
      : +props.clientsData.kupSkd.toString().replaceAll(" ", "")
  );

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const fetchBankAddress = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            nameSelect: el.nameSelect,
            nameLetter: el.nameLetter,
            bankKRS: el.bankKRS,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });
        setBankAddressDb(
          arr.filter((el) => el.nameSelect === props.clientsData.bank)[0]
        );
        fetchLawyers();
      })
      .catch((error) => {});
  };

  const fetchLawyers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawyers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawyersData(data);
        fetchHolidays();
      })
      .catch((error) => {});
  };

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        setLastPaymentDate(generateLastPayDate());
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const generateLastPayDate = () => {
    var date =
      props.clientsData.wezwLastPayDate === null ||
      props.clientsData.wezwLastPayDate === "całkowitej spłaty kredytu"
        ? ""
        : props.clientsData.wezwLastPayDate;

    if (date !== "") {
      date = date.replaceAll("r.", "");
      var dateA = date.split(" ");
      var day = dateA[0];
      var month = getMonthNumber(dateA[1]);
      var year = dateA[2];

      return year + "-" + month + "-" + day;
    } else {
      return date;
    }
  };

  const getData = async () => {
    fetchBankAddress();
  };

  useEffect(() => {
    getData();
  }, []);

  function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
  }

  const generateClientName = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      table.map((el, index) => {
        text = text + el + (index + 1 === table.length ? "" : ",");
      });
      return text.toString();
    } else {
      return table;
    }
  };

  const getMonthName = (month) => {
    if (month === 1) {
      return "stycznia";
    }
    if (month === 2) {
      return "lutego";
    }
    if (month === 3) {
      return "marca";
    }
    if (month === 4) {
      return "kwietnia";
    }
    if (month === 5) {
      return "maja";
    }
    if (month === 6) {
      return "czerwca";
    }
    if (month === 7) {
      return "lipca";
    }
    if (month === 8) {
      return "sierpnia";
    }
    if (month === 9) {
      return "września";
    }
    if (month === 10) {
      return "października";
    }
    if (month === 11) {
      return "listopada";
    }
    if (month === 12) {
      return "grudnia";
    }
  };

  const getMonthNumber = (month) => {
    if (month === "stycznia") {
      return "01";
    }
    if (month === "lutego") {
      return "02";
    }
    if (month === "marca") {
      return "03";
    }
    if (month === "kwietnia") {
      return "04";
    }
    if (month === "maja") {
      return "05";
    }
    if (month === "czerwca") {
      return "06";
    }
    if (month === "lipca") {
      return "07";
    }
    if (month === "sierpnia") {
      return "08";
    }
    if (month === "września") {
      return "09";
    }
    if (month === "października") {
      return "10";
    }
    if (month === "listopada") {
      return "11";
    }
    if (month === "grudnia") {
      return "12";
    }
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validate = () => {
    if (+plnValue <= 0) {
      return false;
    }
    if (dateOpt === "1") {
      if (lastPaymentDate.length <= 0) {
        return false;
      }
    }
    return true;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addDayThree = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 3));
    return retDate;
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= final_date && el.date_from <= final_date) ||
          (final_date >= el.date_from && final_date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const getBank = (bank) => {
    if (bank === "Raiffeisen Bank International AG") {
      return "Raiffeisen Bank International AG z siedzibą w Wiedniu działający przez Raiffeisen Bank International AG (Spółka Akcyjna) Oddział w Polsce";
    }
    if (bank === "PKO BP S.A.") {
      return "Powszechna Kasa Oszczędności Bank Polski S.A.";
    }
    if (bank === "PEKAO S.A.") {
      return "Bank Polska Kasa Opieki – Spółka Akcyjna";
    }
    return bank;
  };

  const generateDocument = async () => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }

    var bankTr = getBank(bankAddressDb.nameLetter);
    var plnValueTr = numberWithCommas(
      +plnValue === undefined || plnValue === "" ? 0 : plnValue
    );
    var chfValueTr = numberWithCommas(
      +chfValue === undefined || chfValue === "" ? 0 : chfValue
    );
    var lastPaymentDateTr =
      dateOpt === "1"
        ? (new Date(lastPaymentDate).getDate() < 10
            ? "0" + new Date(lastPaymentDate).getDate()
            : new Date(lastPaymentDate).getDate()) +
          " " +
          getMonthName(new Date(lastPaymentDate).getMonth() + 1) +
          " " +
          new Date(lastPaymentDate).getFullYear() +
          " r."
        : "całkowitej spłaty kredytu";
    var payTimeTr = payTime;

    var bodyX = {
      clientId: props.clientsData.id,
      wezwPlnValue: numberWithCommas(plnValueTr),
      wezwChfValue: numberWithCommas(chfValueTr),
      wezwLastPayDate: lastPaymentDateTr,
      wezwPayTime: payTimeTr,
      koSkd: numberWithCommas(koSkd),
      izrSkd: numberWithCommas(izrSkd),
      irSkd: irSkd,
      kpSkd: numberWithCommas(kpSkd),
      kupSkd: numberWithCommas(kupSkd),
    };

    fetch("https://apidevkppp.ftpeople.pl/updateWezwData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(bodyX),
    })
      .then((response) => response.text())
      .then((responseJson) => {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "informacje z wezwania",
        }).then(async (result) => {
          props.close();
        });
      });
  };

  const setDateOptF = (e) => {
    setDateOpt(e.target.value);
    if (e.target.value === "1") {
      setLastPaymentDate("");
    } else {
      setLastPaymentDate("całkowitej spłaty kredytu");
    }
  };

  return (
    <div
      style={{ width: "50vw", top: "5vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div
            id="addPaymentIC"
            className="inputContainer"
            style={{ height: "70vh", overflowY: "scroll" }}
          >
            <>
              <div id="addPaymentIC" className="inputContainer">
                <div className="inputBox">
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Kwota w PLN <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={plnValue}
                      onChange={(e) => {
                        setPlnValue(e.target.value);
                      }}
                      onKeyPress={checkDigit}
                    />
                  </div>
                  {props.clientsData.type !== "sankcja kredytu darmowego" ? (
                    <>
                      <div style={{ minWidth: "49%" }} className="inputCol_2">
                        <label>Kwota w CHF</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={chfValue}
                          onChange={(e) => {
                            setChfValue(e.target.value);
                          }}
                          onKeyPress={checkDigit}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inputBox">
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Data ostatniej wpłaty{" "}
                      <span className="requiredStar">*</span>
                    </label>
                    <div style={{ marginTop: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <input
                          style={{
                            width: "20px",
                            margin: "0",
                            height: "2vh",
                            boxShadow: "none",
                          }}
                          type="radio"
                          value="1"
                          checked={dateOpt === "1" ? true : false}
                          name="gender"
                          onChange={setDateOptF}
                        />{" "}
                        Data z kalendarza
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <input
                          style={{
                            width: "20px",
                            margin: "0",
                            height: "2vh",
                            boxShadow: "none",
                          }}
                          type="radio"
                          value="2"
                          checked={dateOpt === "2" ? true : false}
                          name="gender"
                          onChange={setDateOptF}
                        />{" "}
                        Całkowita spłata kredytu
                      </div>
                    </div>
                  </div>
                  {dateOpt === "1" ? (
                    <>
                      {" "}
                      <div
                        style={{
                          minWidth: "49%",
                          display: "flex",
                          alignItems: "center",
                        }}
                        className="inputCol_2"
                      >
                        <input
                          type="date"
                          id="name"
                          name="name"
                          value={lastPaymentDate}
                          onChange={(e) => {
                            setLastPaymentDate(e.target.value);
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inputBox">
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Termin płatności <span className="requiredStar">*</span>
                    </label>
                    <div style={{ marginTop: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <input
                          style={{
                            width: "20px",
                            margin: "0",
                            height: "2vh",
                            boxShadow: "none",
                          }}
                          type="radio"
                          value="3 dni"
                          checked={payTime === "3 dni" ? true : false}
                          name="payTime"
                          onChange={(e) => setPayTime(e.target.value)}
                        />{" "}
                        3 dni
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <input
                          style={{
                            width: "20px",
                            margin: "0",
                            height: "2vh",
                            boxShadow: "none",
                          }}
                          type="radio"
                          value="7 dni"
                          checked={payTime === "7 dni" ? true : false}
                          name="payTime"
                          onChange={(e) => setPayTime(e.target.value)}
                        />{" "}
                        7 dni
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <input
                          style={{
                            width: "20px",
                            margin: "0",
                            height: "2vh",
                            boxShadow: "none",
                          }}
                          type="radio"
                          value="14 dni"
                          checked={payTime === "14 dni" ? true : false}
                          name="payTime"
                          onChange={(e) => setPayTime(e.target.value)}
                        />{" "}
                        14 dni
                      </div>
                    </div>
                  </div>
                </div>
                {props.clientsData.type === "sankcja kredytu darmowego" ? (
                  <>
                    <div className="inputBox">
                      <div style={{ minWidth: "90%" }} className="inputCol_1">
                        <label>Kwota odsetek</label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={koSkd}
                          onChange={(e) => {
                            setKoSkd(e.target.value);
                          }}
                          onKeyPress={checkDigit}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      <div style={{ minWidth: "90%" }} className="inputCol_1">
                        <label>Ilość zapłaconych rat</label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={izrSkd}
                          onChange={(e) => {
                            setIzrSkd(e.target.value);
                          }}
                          onKeyPress={checkDigit}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      <div style={{ minWidth: "90%" }} className="inputCol_1">
                        <label>Ilość rat</label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={irSkd}
                          onChange={(e) => {
                            setIrSkd(e.target.value);
                          }}
                          onKeyPress={checkDigit}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      <div style={{ minWidth: "90%" }} className="inputCol_1">
                        <label>Kwota prowizji</label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={kpSkd}
                          onChange={(e) => {
                            setKpSkd(e.target.value.replaceAll(",", "."));
                            if (
                              izrSkd
                                .toString()
                                .replaceAll(" ", "")
                                .replaceAll(",", ".") > 0 &&
                              irSkd
                                .toString()
                                .replaceAll(" ", "")
                                .replaceAll(",", ".") > 0
                            ) {
                              setKupSkd(
                                Number(
                                  (izrSkd
                                    .toString()
                                    .replaceAll(" ", "")
                                    .replaceAll(".", ",") /
                                    irSkd
                                      .toString()
                                      .replaceAll(" ", "")
                                      .replaceAll(".", ",")) *
                                    e.target.value.replaceAll(",", ".")
                                ).toFixed(2)
                              );

                              setPlnValue(
                                Number(
                                  (izrSkd / irSkd) *
                                    +e.target.value.replaceAll(",", ".") +
                                    +koSkd.toString().replaceAll(",", ".")
                                ).toFixed(2)
                              );
                            }
                          }}
                          onKeyPress={checkDigit}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      <div style={{ minWidth: "90%" }} className="inputCol_1">
                        <label>Kwota uiszczonej prowizji</label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={kupSkd}
                          onChange={(e) => {
                            setKupSkd(e.target.value);
                          }}
                          onKeyPress={checkDigit}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={generateDocument}>
                ZAPISZ
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EditWezwData;
